<template>
    <div>
        <apexcharts
        ref="barchart"
        width="100%"
        height="350"
        type="pie"
        :options="options"
        :series="options.series"
        ></apexcharts>
        <div class="block">
            <div align="center">Projetos</div>
            <div class="total" align="center">Total: {{this.saldo}}</div>
        </div>
    </div>
</template>

<script>
    import ApexCharts from 'apexcharts'
    import VueApexchar from 'vue-apexcharts'
    import { get } from "@/helpers/api";
    import { utils } from "../relatorios/mixins/index";
    export default {
        name:'Projetos',
        mixins: [utils],
        components: {
            'apexcharts': VueApexchar
        },

        props: ['cliente'],
        data () {
            return {
                db: [],
                options: {},
                image: null,
                projeto:[],
                saldo:null
            }
        },
        methods:{
            async plot(){

                if (! this.$refs.barchart) return '';
                
                await this.$refs.barchart.chart.dataURI().then(uri => {
                    this.image = uri || 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII='
                });
                return `<div>
                            <img src="${this.image}" />
                            <div align="center">Projetos</div>
                            <div style="font-size: 12px;" align="center">
                                Total: ${this.saldo}
                            </div>
                        </div>`;
            },
            jsonToObject(j){
                return Object.keys(j).map(function(_) { return j[_]; })
            },
            readyData(a,b){
                this.options = {
                    chart: {
                        width: "100%",
                        height: 'auto',
                        type: 'pie',
                        zoom: {
                            enabled: false
                        }
                    },
                    dataLabels: {
                        enabled: true,
                        style: {
                            colors: ['#000']
                        },
                    },
                    series: [a, b],
                    //colors: ['#ffc059','#ff6565','#ff8373','#4ad991','#00e5ff','#9c9d9e'],
                    labels: [
                        'Reserva Atual - '+this.real(a),
                        'Necessidade de Complementação - '+this.real(b)
                    ],
                    legend: {
                        position: 'right',
                        fontSize: '14px',
                        itemMargin: {
                            horizontal: 8,
                            vertical: 3
                        },
                    },
                    theme: {
                        mode: 'light',
                        palette: 'palette1'
                    },
                    tooltip:{
                        theme:'dark'
                        
                    },
                    responsive: [{
                        breakpoint: 1331,
                        options: {
                            plotOptions:{
                                pie: {
                                    size: 150,
                                    customScale: 1
                                }
                            },
                            legend: {
                                position: "bottom"
                            }
                        }
                    }]
                }
            },
            async getData(){

                const projeto = this.cliente.projeto;
                
                if(projeto != null) {
                    this.projeto = this.jsonToObject(projeto)
                }
                const reserva_atual = parseFloat(this.projeto[4] ? this.projeto[4] : 0);
                const necessidade = (parseFloat(this.projeto[2] ? this.projeto[2] : 0) - reserva_atual);
                
                if(projeto != null) {
                    this.saldo = this.real(this.total(reserva_atual, necessidade))
                    this.db.push(reserva_atual, necessidade)
                    this.readyData(reserva_atual, necessidade)
                }
            
            }
        },
        mounted () {
            this.getData()
        }
    }
</script>

<style lang="css" scoped>
.graph{
    text-align: center;
}
.total{
    font-size: 12px;
}
.block{
    width: 300px;
    margin-left: 120px;
    display: contents;
}
@media (min-width: 320px) and (max-width: 480px) {
   .block{
        width: 300px;
        margin-left: 25px;
        display: block;
    } 
}
</style>


// WEBPACK FOOTER //
// src/components/graficos-simulador/Projetos.vue